var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-huge",on:{"click":function($event){return _vm.$router.replace('/')}}},[_c('van-empty',{attrs:{"image":"error","description":_vm.$t('common.error.badRequest')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }